module.exports = "<react-getting-started-progress></react-getting-started-progress>\n<react-copy-move-post></react-copy-move-post>\n";